import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import BuoyIcon from "../assets/icons/BuoyIcon";
import AppLayout from "../layouts/AppLayout";

type NotFoundProps = {
  title?: string;
  buttonText?: string;
};

export default function NotFound({
  title = "Sorry, page not found",
  buttonText = "Back to Home",
}: NotFoundProps) {
  const navigate = useNavigate();

  return (
    <AppLayout
      className="w-screen flex justify-center relative"
      title="Notfound"
    >
      <div className="mt-20 text-center">
        <h2 className="flex items-center text-center justify-center gap-2 text-8xl text-primary/50">
          4
          <BuoyIcon
            width={65}
            height={65}
            className="animate-buoy_icon"
            pathClass="!fill-primary"
          />
          4
        </h2>
        <h4 className="text-primary text-xl font-semibold uppercase mt-4 mb-8">
          {title}
        </h4>
        <div>
          <Button
            className="bg-primary"
            type="primary"
            size="middle"
            onClick={() => navigate(-1)}
          >
            {buttonText}
          </Button>
        </div>
      </div>
    </AppLayout>
  );
}
